import clsx from 'clsx'
import { FC, PropsWithChildren, SVGProps, useMemo } from 'react'

import { LineTagType } from '@/components/LineItem/LineItem'

interface TagProps {
  className?: string
  renderLeftIcon?: FC<SVGProps<SVGSVGElement>>
  renderRightIcon?: FC<SVGProps<SVGSVGElement>>
  size?: 'regular' | 'small'
  variant?: LineTagType | 'warning'
}

export function Tag({
  renderLeftIcon: LeftIcon,
  renderRightIcon: RightIcon,
  children,
  className = '',
  size = 'regular',
  variant = 'info',
}: PropsWithChildren<TagProps>) {
  const variantTailwind = useMemo(() => {
    return TagVariantStyles[variant]
  }, [variant])

  return (
    <div
      className={clsx(
        'flex items-center justify-center w-fit-content h-fit-content font-medium rounded-lg [&_svg]:mr-1.5 [&_span.button-text~svg]:ml-1.5 [&_span.button-text~svg]:mr-0',
        size === 'small' ? 'text-xs px-4 py-2' : 'text-base px-3 py-2',
        variantTailwind,
        className,
      )}
    >
      {LeftIcon && <LeftIcon />}
      <span className="tag-text whitespace-nowrap">{children}</span>
      {RightIcon && <RightIcon />}
    </div>
  )
}

export const TagVariantStyles = {
  success: 'tag-green-light text-semantic-success',
  warning: 'tag-yellow-light text-yellow-300',
  error: 'bg-red-100 text-red-300',
  info: 'tag-blue-light',
  none: '',
}
